import { API_ROUTES } from '@/constants';
import { APP_ROUTES } from '@/routes';
import { MappingType } from '@/types';

type UploadPageConfig = {
  mappingType: MappingType;
  downloadTemplateLink: string;
};

export const getUploadPageConfig = (path: string) => {
  const uploadPageConfig = {} as UploadPageConfig;
  const uploadPages = [APP_ROUTES.loansUploadMapping, APP_ROUTES.sharesUploadMapping, APP_ROUTES.codeUploadMapping];
  const isUploadPage = uploadPages.some((page) => path.includes(page) && path.includes('/upload'));

  if (isUploadPage) {
    switch (path) {
      case APP_ROUTES.loansUploadMapping:
        uploadPageConfig.mappingType = MappingType.loans;
        uploadPageConfig.downloadTemplateLink = API_ROUTES.DOWNLOAD_LOAN_TEMPLATE;
        break;

      case APP_ROUTES.sharesUploadMapping:
        uploadPageConfig.mappingType = MappingType.shares;
        uploadPageConfig.downloadTemplateLink = API_ROUTES.DOWNLOAD_SHARE_TEMPLATE;
        break;

      case APP_ROUTES.codeUploadMapping:
        uploadPageConfig.mappingType = MappingType.pfc;
        uploadPageConfig.downloadTemplateLink = API_ROUTES.DOWNLOAD_PFC_TEMPLATE;
        break;

      default:
        break;
    }
  }

  return {
    isUploadPage,
    uploadPageConfig,
  };
};
